import sheetEventListStore from '@modules/sheet-event/sheet-event-list-store';
import sheetEventViewStore from '@modules/sheet-event/sheet-event-view-store';
import sheetEventImporterStore from '@modules/sheet-event/sheet-event-importer-store';
import sheetEventFormStore from '@modules/sheet-event/sheet-event-form-store';
import sheetEventDestroyStore from '@modules/sheet-event/sheet-event-destroy-store';

export default {
  namespaced: true,

  modules: {
    destroy: sheetEventDestroyStore,
    form: sheetEventFormStore,
    list: sheetEventListStore,
    view: sheetEventViewStore,
    importer: sheetEventImporterStore,
  },
};
